<template>
  <Modal v-model="supplierWarehouseModal" :title="supplierWarehouseTitle" width="1000" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false" @on-visible-change="supplierWarehouseChange">
    <Form ref="supplierWarehouseForm" :model="supplierWarehouseForm" :rules="ruleValidate" :label-width="110" @submit.native.prevent>
      <!--基本信息-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row style="width: 95%">
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002327')" prop="warehouseName">
              <Input clearable v-model.trim="supplierWarehouseForm.warehouseName" :placeholder="$t('key1000324')" :maxlength="50"></Input>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002352')" prop="warehouseCode">
              <Input clearable v-model.trim="supplierWarehouseForm.warehouseCode" :placeholder="$t('key1000324')" :maxlength="50"></Input>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002433')" prop="ymsDeliveryPlaceId">
              <Select v-model="supplierWarehouseForm.ymsDeliveryPlaceId" transfer filterable @on-change="warehouseDeliveryPlaceChange">
                <Option v-for="(item, index) in placeOfShipmentList" :value="item.ymsDeliveryPlaceId" :key="index">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002164')" prop="warehouseStatus">
              <Select v-model="supplierWarehouseForm.warehouseStatus" transfer filterable>
                <Option v-for="(item, index) in statusList" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Card>
      <!--仓库配置-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1002353') }}</h2>
          </template>
          <!--仓库类型-->
          <div class="flex align-items-center mb30">
            <span>{{ $t('key1002354') }}</span>
            <CheckboxGroup v-model="supplierWarehouseForm.warehouseTypes" class="flex align-items-center">
              <Checkbox :disabled="true" label="isCollectionWarehouse">{{ $t('key1002114') }}</Checkbox>
              <Checkbox :disabled="true" label="isDeliveryWarehouse">{{ $t('key1002115') }}</Checkbox>
            </CheckboxGroup>
          </div>
          <template v-if="supplierWarehouseType === 'edit'">
            <!--供货仓配置-->
            <Card :bordered="false" dis-hover v-if="supplierWarehouseForm.warehouseTypes.includes('isCollectionWarehouse')">
              <template #title>
                <h2 class="title_box">{{ $t('key1002355') }}</h2>
              </template>
              <Row type="flex" :gutter="gutterItem">
                <Col :span="24" class="basic_item" style="align-items: flex-start;">
                  <div class="flex align-items-center width_205">
                    <Tooltip :content="$t('key1002346')" max-width="400" placement="top" transfer>
                      <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                    </Tooltip>
                    <span class="basic_title red-dot">{{ $t('key1002804') }}</span>
                  </div>
                  <CheckboxGroup v-model="supplierWarehouseForm.consolidationWarehouseList" class="flex flex-wrap flex_1">
                    <Checkbox class="mr30" v-for="item in consolidationWarehouseData" :label="item.ymsWarehouseId">{{ item.name }}</Checkbox>
                  </CheckboxGroup>
                </Col>
                <Col :span="24" class="basic_item">
                  <span class="basic_title">{{ $t('key1002357') }}</span>
                  <RadioGroup v-model="supplierWarehouseForm.allowedPrintLogisticsSheet">
                    <Radio :disabled="true" :label="1">{{ $t('key1000392') }}</Radio>
                    <Radio :disabled="true" :label="0">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                </Col>
              </Row>
            </Card>
            <!--直发仓配置-->
            <Card :bordered="false" dis-hover v-if="supplierWarehouseForm.warehouseTypes.includes('isDeliveryWarehouse')">
              <template #title>
                <h2 class="title_box">{{ $t('key1002358') }}</h2>
              </template>
              <div class="flex align-items-center mb20">
                <Tooltip :content="$t('key1002348')" max-width="400" placement="top" transfer>
                  <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                </Tooltip>
                <span class="basic_title red-dot">{{ $t('key1002363') }}</span>
              </div>
              <Tabs v-model="logisticsType" :animated="false" @on-click="changeTab">
                <TabPane :label="$t('key1001587')" name="selfOwnedLogistics"></TabPane>
                <TabPane :label="$t('key1002349')" name="thirdPartyLogistics"></TabPane>
              </Tabs>
              <!--自有物流-->
              <template v-if="logisticsType === 'selfOwnedLogistics'">
                <Tabs type="card" :animated="false" v-model="logisticsChannelsType">
                  <TabPane v-for="(item,index) in selfOwnedLogisticsData" :label="item.carrierName" :name="item.type + '_' + index">
                    <Checkbox class="display-inline-block mb15" v-model="item.selectAllLogisticsOptions"
                      :indeterminate="item.indeterminate" @on-change="handleCheckAllChange(item)">{{ $t('key1000110') }}
                    </Checkbox>
                    <CheckboxGroup :key="item.type + '_' + index" v-model="item.logisticsSelectionList" class="flex flex-wrap" @on-change="handleSingleChange(item)">
                      <Checkbox class="mb10 mr25" v-for="ele in item.carrierShippingMethods" :label="ele.shippingMethodId">{{ ele.carrierShippingMethodName }}</Checkbox>
                    </CheckboxGroup>
                  </TabPane>
                </Tabs>
              </template>
              <!--第三方物流-->
              <template v-if="logisticsType === 'thirdPartyLogistics'">
                <Tabs type="card" :animated="false" v-model="logisticsChannelsType">
                  <TabPane v-for="(item,index) in thirdPartyLogisticsData" :label="item.carrierName" :name="item.type + '_' + index">
                    <Checkbox class="display-inline-block mb15" v-model="item.selectAllLogisticsOptions"
                      :indeterminate="item.indeterminate" @on-change="handleCheckAllChange(item)">{{ $t('key1000110') }}
                    </Checkbox>
                    <CheckboxGroup :key="item.type + '_' + index" v-model="item.logisticsSelectionList" class="flex flex-wrap" @on-change="handleSingleChange(item)">
                      <Checkbox class="mb10 mr25" v-for="ele in item.carrierShippingMethods" :label="ele.shippingMethodId">{{ ele.carrierShippingMethodName }}</Checkbox>
                    </CheckboxGroup>
                  </TabPane>
                </Tabs>
              </template>
            </Card>
          </template>
        </Card>
      </div>
      <!--仓库地址-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002364') }}</h2>
        </template>
        <Row style="width: 95%">
          <!--发货地址-->
          <h3 class="color-333 pl20 font-size-13">{{ $t('key1002365') }}</h3>
          <Divider style="margin: 5px 0 15px 0"/>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002436')" prop="ymsAddressTemplateId">
              <div class="flex align-items-center">
                <Select
                  :placeholder="$t('key1007117')"
                  :disabled="!supplierWarehouseForm.ymsDeliveryPlaceId"
                  @on-change="selectChange"
                  @on-open-change="openSendAddressChange"
                  v-model="supplierWarehouseForm.ymsAddressTemplateId"
                  transfer
                  filterable
                  style="width: 250px;">
                  <Option v-for="(item, index) in addressTemplateList" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                    <span v-html="item.templateName"></span>
                  </Option>
                </Select>
                <span class="cursor themeColor ml8 font-size-13" v-if="supplierWarehouseForm.ymsDeliveryPlaceId" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
              </div>
            </Form-item>
          </Col>
          <!--发货地址详情-->
          <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="Object.keys(addressDetails).length >0">
            <Col :span="12" class="basic_item" v-for="ele in addressInfoList">
              <span class="basic_title">{{ ele.title + '：' }}</span>
              <span class="basic_txt" :title="addressDetails[ele.paramsKey]">{{ addressDetails[ele.paramsKey] || '--' }}</span>
            </Col>
          </Row>
          <!--退货地址-->
          <h3 class="color-333 mt30 pl20 font-size-13">{{ $t('key1002366') }}</h3>
          <Divider style="margin: 5px 0 15px 0"/>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002436')" prop="returnAddressTemplateId">
              <div class="flex align-items-center">
                <Select
                  @on-change="selectReturnAddressChange"
                  @on-open-change="openReturnAddressChange"
                  v-model="supplierWarehouseForm.returnAddressTemplateId"
                  transfer
                  filterable
                  style="width: 250px;">
                  <Option v-for="(item, index) in returnAddressTemplateList" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                    <span v-html="item.templateName"></span>
                  </Option>
                </Select>
                <span class="cursor themeColor ml8 font-size-13" v-if="supplierWarehouseForm.ymsDeliveryPlaceId" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
              </div>
            </Form-item>
          </Col>
          <!--退货地址详情-->
          <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="Object.keys(returnAddressDetails).length >0">
            <Col :span="12" class="basic_item" v-for="ele in addressInfoList">
              <span class="basic_title">{{ ele.title + '：' }}</span>
              <span class="basic_txt" :title="returnAddressDetails[ele.paramsKey]">{{ returnAddressDetails[ele.paramsKey] || '--' }}</span>
            </Col>
          </Row>
        </Row>
      </Card>
    </Form>
    <template #footer>
      <Button @click="supplierWarehouseModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="supplierWarehouseBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDeliveryAreasAllData, isJSON} from "@/utils/common";

export default {
  name: 'supplierWarehouseModal',
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      supplierWarehouseModal: false,
      supplierWarehouseTitle: '',
      supplierWarehouseType: null,
      supplierWarehouseForm: {
        warehouseName: '',
        warehouseCode: '',
        ymsDeliveryPlaceId: null,
        warehouseStatus: 0, // 状态
        ymsAddressTemplateId: null, // 发货地址模板选择
        returnAddressTemplateId: null, // 退货地址模板选择
        warehouseTypes: [], // 仓库类型
        consolidationWarehouseList: [], // 供货目标集货仓
        allowedPrintLogisticsSheet: 0, // 是否可打印物流面单
      },
      ruleValidate: {
        warehouseName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002316'), trigger: 'blur'}
        ],
        warehouseCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002415'), trigger: 'blur'}
        ],
        ymsDeliveryPlaceId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002417'), trigger: 'change'}
        ],
        warehouseStatus: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007111'), trigger: 'change'}
        ],
        ymsAddressTemplateId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007112'), trigger: 'change'}
        ],
        returnAddressTemplateId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007113'), trigger: 'change'}
        ]
      },
      placeOfShipmentList: [],
      statusList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
      ],
      countrysList: [],
      consolidationWarehouseData: [],
      logisticsType: 'selfOwnedLogistics',
      logisticsChannelsType: 'selfOwnedLogistics_0',
      returnAddressDetails: {},
      addressDetails: {},
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCodeName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      addressTemplateList: [],
      returnAddressTemplateList: [],
      warehouseId: null,
      selfOwnedLogisticsData: [],
      thirdPartyLogisticsData: [],
    }
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initSupplierWarehouseData(type, obj) {
      let v = this;
      let title = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007114'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184')
      }
      v.supplierWarehouseTitle = title[type];
      v.supplierWarehouseType = type;
      v.returnAddressTemplateList = [];
      (async () => {
        await v.getAddressTemplateData('supplier', v.userInfo.merchantId).then((data) => {
          v.returnAddressTemplateList = data;
        });
        await getDeliveryAreasAllData().then((data) => {
          v.placeOfShipmentList = data;
        });
        await v.getLogisticsDataEnabledAllData();
        if (type === 'edit') {
          v.warehouseId = obj.warehouseId;
          v.getWarehouseDetails(obj.warehouseId);
        } else {
          v.$nextTick(() => {
            v.$refs['supplierWarehouseForm'].resetFields();
          });
          v.supplierWarehouseModal = true;
        }
      })();
    },
    // 获取仓库详情
    async getWarehouseDetails(warehouseId) {
      const response = await this.axios.get(api.get_wmsWarehouse_detail + warehouseId, {loading: true});
      if (response.data.code === 0) {
        let data = response.data.datas;
        if (data) {
          data.warehouseStatus = Number(data.warehouseStatus);
          data.allowedPrintLogisticsSheet = Number(data.allowedPrintLogisticsSheet);

          // 仓库地址
          if (data.ymsDeliveryPlaceId) {
            await this.getStoreGoodsData(data.ymsDeliveryPlaceId);
            await this.warehouseDeliveryPlaceChange(data.ymsDeliveryPlaceId).then(() => {
              this.selectChange(data.ymsAddressTemplateId)
            });
          }
          if (data.returnAddressTemplateId) {
            this.selectReturnAddressChange(data.returnAddressTemplateId)
          }
          // 仓库类型
          data.warehouseTypes = [
            ...(data.isCollectionWarehouse === 1 ? ['isCollectionWarehouse'] : []),
            ...(data.isDeliveryWarehouse === 1 ? ['isDeliveryWarehouse'] : [])
          ];
          // 供货仓配置
          let ymsWarehouseCollectionSettingList = data.ymsWarehouseCollectionSettingList || [];
          if (ymsWarehouseCollectionSettingList.length > 0) {
            const newList = new Set(ymsWarehouseCollectionSettingList
              .filter(setting => setting.targetYmsWarehouseId)
              .map(setting => setting.targetYmsWarehouseId));
            data.consolidationWarehouseList = [];
            this.consolidationWarehouseData.forEach(ele => {
              if (newList.has(ele.ymsWarehouseId)) {
                data.consolidationWarehouseList.push(ele.ymsWarehouseId);
              }
            });
          }
          // 直发仓配置
          let ymsWarehouseDeliverySettingList = data.ymsWarehouseDeliverySettingList || [];
          if (ymsWarehouseDeliverySettingList.length > 0) {
            const grouped = {
              1: [], // 自有物流
              2: []  // 第三方物流
            };
            // 按 carrierType 分组
            ymsWarehouseDeliverySettingList.forEach(ele => {
              const type = Number(ele.carrierType);
              if (grouped[type]) {
                grouped[type].push(ele);
              }
            });
            const updateSelection = (dataList, carrierType) => {
              dataList.forEach(item => {
                item.logisticsSelectionList = grouped[carrierType].filter(ele => ele.carrierId === item.carrierId).map(ele => ele.carrierShippingMethodId);
                this.handleSingleChange(item);
              });
            };
            // 自有物流
            updateSelection(this.selfOwnedLogisticsData, 1);
            // 第三方物流
            updateSelection(this.thirdPartyLogisticsData, 2);
          }
          this.supplierWarehouseForm = data;
          this.supplierWarehouseModal = true;
          this.$forceUpdate();
        }
      }
    },
    // 获取目标集货中心仓的数据
    getStoreGoodsData(ymsDeliveryPlaceId) {
      this.supplierWarehouseForm.consolidationWarehouseList = [];
      this.consolidationWarehouseData = [];
      return new Promise((resolve) => {
        this.axios.get(api.get_wmsWarehouse_getCollectionWarehouse + ymsDeliveryPlaceId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            this.consolidationWarehouseData = data.filter(item => item.status === 1 &&
              (item.collectionWarehouse === 1 || item.stockedWarehouse === 1));
            resolve(data);
          }
        });
      });
    },
    // 获取自有、第三方物流的数据
    async getLogisticsDataEnabledAllData() {
      const query = {
        carrierIds: [],
        carrierName: '',
        status: 1
      };
      const fetchLogisticsData = async (url) => {
        try {
          const response = await this.axios.post(url, query);
          if (response.data.code === 0) {
            return response.data.datas || [];
          }
          return [];
        } catch (error) {
          return [];
        }
      };
      const [selfOwnedLogisticsData, thirdPartyLogisticsData] = await Promise.all([
        fetchLogisticsData(api.post_ymsSupplierCarrier_queryForOwnCarriersList),
        fetchLogisticsData(api.post_ymsSupplierCarrier_queryForThirdCarriersList)
      ]);
      const handleData = (data, type) => data.map(item => ({
        type,
        selectAllLogisticsOptions: false,
        indeterminate: false,
        logisticsSelectionList: [],
        ...item
      }));
      const hanleName = (data) => {
        data.map((item) => {
          const carrierShippingMethodsList = (item.carrierShippingMethods || []).filter(method => method.status === 1);
          item.carrierShippingMethods = carrierShippingMethodsList;
          carrierShippingMethodsList.map((ele) => {
            let name = ele.carrierShippingMethodName;
            if (isJSON(name)) {
              let obj = JSON.parse(name);
              ele.carrierShippingMethodName = obj[this.languagesVal];
            }
          })
        });
        return data;
      }
      this.selfOwnedLogisticsData = handleData(hanleName(selfOwnedLogisticsData), 'selfOwnedLogistics');
      this.thirdPartyLogisticsData = handleData(hanleName(thirdPartyLogisticsData), 'thirdPartyLogistics');
      this.$forceUpdate();
    },
    // 切换物流方式
    changeTab(name) {
      this.logisticsType = name;
      let data = name === 'selfOwnedLogistics' ? this.selfOwnedLogisticsData : this.thirdPartyLogisticsData;
      if (data.length > 0) {
        this.logisticsChannelsType = data[0].type + '_0';
      }
      // 强制更新以确保 CheckboxGroup 正确渲染
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 确定按钮
    supplierWarehouseBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      let {
        warehouseName, warehouseCode, ymsDeliveryPlaceId, warehouseStatus,
        ymsAddressTemplateId, allowedPrintLogisticsSheet, returnAddressTemplateId
      } = v.supplierWarehouseForm;
      let {name, countryCode, countryCodeName, state, city, district, street, phone, postcode, email} = v.addressDetails;
      let query = {
        address: street, // 详细地址
        allowedPrintLogisticsSheet: allowedPrintLogisticsSheet, // 是否可打印物流面单 0 否 1 是
        cityCnName: city, // 市中文名称
        countryCnName: countryCodeName, // 国家中文名称
        countryCode: countryCode, // 国家编码
        district: district, // 区县
        email: email, // 邮箱
        addressZipCode: postcode, // 邮政编码
        isCollectionWarehouse: 0, // 是否是供货仓 0 否 1 是
        isDeliveryWarehouse: 0, // 是否是发货仓 0 否 1 是
        linkMan: name, // 联系人
        mobilePhone: phone, // 手机
        stateCnName: state, // 省/州中文名称
        warehouseCode: warehouseCode, // 仓库代码
        ymsDeliveryPlaceId: ymsDeliveryPlaceId, // 仓库发货地
        warehouseName: warehouseName, // 仓库名称
        warehouseStatus: warehouseStatus, // 仓库状态(0正常1禁用)
        ymsAddressTemplateId: ymsAddressTemplateId,
        returnAddressTemplateId: returnAddressTemplateId
      };
      if (v.supplierWarehouseType === 'add') {
        url = api.post_wmsWarehouse_create;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
        v.$refs['supplierWarehouseForm'].validate((valid) => {
          if (valid) {
            handleData(method, url, query)
          }
        });
      } else {
        url = api.put_wmsWarehouse_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
        query.warehouseId = v.warehouseId;
        query.ymsWarehouseCollectionSettingList = [];
        query.ymsWarehouseDeliverySettingList = [];
        query.isCollectionWarehouse = v.supplierWarehouseForm.isCollectionWarehouse;
        query.isDeliveryWarehouse = v.supplierWarehouseForm.isDeliveryWarehouse;
        // 供货仓配置信息
        let consolidationWarehouseList = v.supplierWarehouseForm.consolidationWarehouseList || [];
        if (consolidationWarehouseList.length > 0) {
          consolidationWarehouseList.map((val) => {
            query.ymsWarehouseCollectionSettingList.push({
              targetYmsWarehouseId: val,
              ymsWarehouseId: v.warehouseId
            })
          })
        }
        // 直发仓配置信息
        let newData = [...v.selfOwnedLogisticsData, ...v.thirdPartyLogisticsData];
        newData.map((item) => {
          let carrierShippingMethodsList = item.carrierShippingMethods || [];
          carrierShippingMethodsList.map((ele) => {
            if (item.logisticsSelectionList.includes(ele.shippingMethodId)) {
              query.ymsWarehouseDeliverySettingList.push({
                carrierId: item.carrierId,
                carrierType: item.type === 'selfOwnedLogistics' ? 1 : 2, // 物流商类型 1 供应商自有物流、 2 第三方物流
                carrierShippingMethodId: ele.shippingMethodId,
                ymsWarehouseId: v.warehouseId,
              })
            }
          })
        });
        v.$refs['supplierWarehouseForm'].validate((valid) => {
          if (valid) {
            if (this.supplierWarehouseForm.warehouseTypes.includes('isCollectionWarehouse') &&
              query.ymsWarehouseCollectionSettingList.length <= 0) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007115'));
              return false;
            }
            if (this.supplierWarehouseForm.warehouseTypes.includes('isDeliveryWarehouse') &&
              query.ymsWarehouseDeliverySettingList.length <= 0) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007116'));
              return false;
            }
            handleData(method, url, query)
          }
        });
      }

      function handleData(method, url, query) {
        v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.supplierWarehouseModal = false;
            v.$Message.success(text);
            v.$emit('updateData');
          }
        });
      }
    },
    // 新增地址模板
    addAddressTemplateBtn() {
      const {href} = this.$router.resolve({
        path: '/addressLibraryManageList',
        query: {
          addressLibraryType: 'add'
        }
      });
      window.open(href, '_blank');
    },
    // 选择发货地址模板
    selectChange(ymsAddressTemplateId) {
      if (this.addressTemplateList.length > 0) {
        let newList = this.addressTemplateList.filter((item) => {
          return item.ymsAddressTemplateId === ymsAddressTemplateId
        });
        if (newList.length > 0) {
          this.addressDetails = newList[0];
          if (this.countrysOriginalData.length > 0) {
            this.countrysOriginalData.map((talg) => {
              if (talg.twoCode === newList[0].countryCode) {
                this.addressDetails.countryCodeName = talg.cnName;
              }
            })
          }
        }
        this.$forceUpdate();
      }
    },
    // 选择退货地址模板
    selectReturnAddressChange(value) {
      let obj = this.returnAddressTemplateList.filter((item) => {
        return item.ymsAddressTemplateId === value
      })[0];
      if (obj) {
        this.returnAddressDetails = JSON.parse(JSON.stringify(obj));
        if (this.countrysOriginalData.length > 0) {
          this.countrysOriginalData.map((talg) => {
            if (talg.twoCode === obj.countryCode) {
              this.returnAddressDetails.countryCodeName = talg.cnName;
            }
          })
        }
      }
    },
    // 实时更新发货地址数据
    openSendAddressChange() {
      let ymsDeliveryPlaceId = this.supplierWarehouseForm.ymsDeliveryPlaceId;
      if (ymsDeliveryPlaceId) {
        this.getSupplierAddressTemplateData(ymsDeliveryPlaceId).then((data) => {
          this.addressTemplateList = data;
        });
      }
    },
    // 实时更新退货地址数据
    openReturnAddressChange() {
      this.getAddressTemplateData('supplier', this.userInfo.merchantId).then((data) => {
        this.returnAddressTemplateList = data;
      });
    },
    // 监听弹窗
    supplierWarehouseChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['supplierWarehouseForm'].resetFields();
        });
        this.addressTemplateList = [];
        this.addressDetails = {};
        this.supplierWarehouseForm.warehouseTypes = [];
        this.supplierWarehouseForm.consolidationWarehouseList = [];
        this.supplierWarehouseForm.allowedPrintLogisticsSheet = 0;
        this.selfOwnedLogisticsData = [];
        this.thirdPartyLogisticsData = [];
        this.logisticsType = 'selfOwnedLogistics';
        this.logisticsChannelsType = 'selfOwnedLogistics_0';
      }
    },
    // 获取已启用地址模板数据
    getSupplierAddressTemplateData(ymsDeliveryPlaceId) {
      return new Promise(resolve => {
        this.axios.get(api.get_ymsSupplierAddressTemplate_chooseList + ymsDeliveryPlaceId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            data.map((item) => {
              let name =
                item.addressName +
                "<br/>" +
                item.name +
                " " +
                item.phone +
                "<br/>" +
                item.state +
                "<br/>" +
                item.city +
                "<br/>" +
                item.district +
                "<br/>" +
                item.street;
              item.templateName = name;
            });
            resolve(data);
          }
        });
      });
    },
    // 选择发货地
    warehouseDeliveryPlaceChange(ymsDeliveryPlaceId) {
      return new Promise((resolve) => {
        if (ymsDeliveryPlaceId) {
          this.supplierWarehouseForm.ymsAddressTemplateId = null;
          this.addressTemplateList = [];
          this.addressDetails = {};
          this.getSupplierAddressTemplateData(ymsDeliveryPlaceId).then((data) => {
            this.addressTemplateList = data;
            resolve(data)
          });
          if (this.supplierWarehouseForm.warehouseTypes.includes('isCollectionWarehouse')) {
            this.getStoreGoodsData(ymsDeliveryPlaceId);
          }
        }
      });
    },
    // 全选当前物流商下的所有渠道
    handleCheckAllChange(item) {
      if (item.selectAllLogisticsOptions) {
        item.logisticsSelectionList = item.carrierShippingMethods.map(channel => channel.shippingMethodId);
      } else {
        item.logisticsSelectionList = [];
      }
      item.indeterminate = false;
    },
    // 勾选物流渠道
    handleSingleChange(item) {
      const checkedCount = item.logisticsSelectionList.length;
      const totalCount = item.carrierShippingMethods?.length;
      item.selectAllLogisticsOptions = checkedCount === totalCount;
      item.indeterminate = checkedCount > 0 && checkedCount < totalCount;
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .commonModalStyles {
  .ivu-card-head {
    padding-left: 0;

    .title_box {
      color: #333;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
